import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ApiCalling from "../../../../network/ApiCalling";
import Util from "../../../../Util";
import Loader from "../../../../components/common/Loader";
import TagButton from "../../../Dashbord/TagButton";
import {
  greenTagStyle,
  orangeTagStyle,
  redTagStyle,
} from "../../../Dashbord/TagButtonStyle";
import PaymentView from "../PaymentView";
import { useSelector } from "react-redux";
import { getUpdatedSchool } from "../../../../components/CommonApis";

export default function AllPaymentList() {
  const { t } = useTranslation();
  const history = useHistory();
  const user = Util.getUser();
  const selected = useSelector((state) => state.SelectedStudentReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [allCreditList, setAllCreditList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(5);
  const [isVisiblePayment, setIsVisiblePayment] = useState(false);
  const [paymentId, setPaymentId] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [schoolLoading, setSchoolLoading] = useState(true);
  const [isSchool, setIsSchool] = useState(null);

  const school = Util.getSelectedSchool();
  const handlePreviousClick = () => {
    if (currentPage !== 1) {
      setCurrentPage((currentPage) => currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage !== totalPages) {
      setCurrentPage((currentPage) => currentPage + 1);
    }
  };

  const getAllCredits = () => {
    setIsLoading(true);
    const data = {
      student_id: selected !== null && selected.selectedStudent.id,
      page: currentPage,
      size: recordPerPage,
    };
    ApiCalling.apiCallBodyDataPost(
      "payment/student",
      data,
      selected.selectedStudent.student.School.id
    )
      .then((res) => {
        if (res.data) {
          setIsLoading(false);
          setAllCreditList(res.data.response);
          setTotalPages(res.data.total);
          setTotalBalance(res.data.credit);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    if (Util.isValidData(selected)) {
      getAllCredits();
    }
  }, [currentPage, recordPerPage, selected]);

  useEffect(() => {
    async function fetchData() {
      const schooldata = await getUpdatedSchool(school.id);
      setIsSchool(schooldata);
      setSchoolLoading(false);
    }

    fetchData();
  }, [school.id]);

  if (schoolLoading) {
    return <Loader />;
  }

  if (!isSchool?.billing) {
    return (
      <div
        className="d-flex justify-content-center"
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          color: "#ed3131",
          alignItems: "center",
          height: "500px",
        }}
      >
        Module Access Denied
      </div>
    );
  }

  return (
    <div>
      <div className="container-fluid">
        <div className="body">
          <div className="row">
            <div className="col-md-12">
              <div className="py-3 pl-2">
                <h2 className="page-head mb-1">{t("All Payment History")} </h2>
                <h6>
                  {t("Total Available credit")}:{" "}
                  {Util.isValidData(totalBalance) &&
                    Util.balanceFormat(totalBalance)}
                </h6>
              </div>

              {!isLoading ? (
                <table
                  className="table"
                  style={{ border: "1px solid #e5e7eb", borderRadius: "12px" }}
                >
                  <thead style={{ backgroundColor: "#e5e7eb" }}>
                    <tr>
                      <th>{t("Payer")}</th>
                      <th>{t("Date")}</th>
                      <th>{t("Status")}</th>
                      <th>{t("Invoices")}</th>
                      <th>{t("Amount")}</th>
                      <th>{t("Balance")}</th>
                      <th></th>
                    </tr>
                  </thead>
                  {allCreditList.length > 0 ? (
                    <tbody>
                      {allCreditList.map((c, index) => {
                        const invoice_settled_ids = c.invoice_settled.map(
                          (c) => c.invoice_id
                        );

                        const invoice_settled = invoice_settled_ids.map(
                          (id) => {
                            return Util.invoiceIdFormat(id);
                          }
                        );

                        return (
                          <tr key={index}>
                            <td>
                              {c.payment_method}
                              <div className="small-text">
                                {t("By")}{" "}
                                {c.User.firstName + " " + c.User.lastName}
                              </div>
                            </td>
                            <td>
                              {moment(c.date).format(
                                Util.getMomentDateTimeFormat(
                                  school?.date_format
                                )
                              )}
                            </td>
                            <td>
                              <TagButton
                                style={"btn btn-secondary"}
                                size={"150px"}
                                title={Util.getPaymentStatus(c.status)}
                                buttonStyle={
                                  c.status == 0
                                    ? redTagStyle
                                    : c.status == 1
                                    ? orangeTagStyle
                                    : greenTagStyle
                                }
                                icon="fa fa-circle"
                                iconSize="6px"
                              />
                            </td>
                            <td>
                              <p style={{ whiteSpace: "pre-line" }}>
                                {c.invoice_settled.length > 0
                                  ? Util.getListDisplay(
                                      invoice_settled,
                                      1,
                                      "\n"
                                    )
                                  : "-"}
                              </p>
                            </td>
                            <td>{Util.amountFormat(c.amount)}</td>
                            <td>{Util.balanceFormat(c.not_used_amount)}</td>
                            <td>
                              <div className="dropdown">
                                <button
                                  className="btn btn-lg custom-primary"
                                  type="button"
                                  id="dropdownMenuButton1"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{
                                    color: "#ffffff",
                                    padding: "5px, 10px",
                                  }}
                                >
                                  {t("Action")}
                                </button>
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                >
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() => {
                                        setIsVisiblePayment(true);
                                        setPaymentId(c.id);
                                      }}
                                    >
                                      {t("View")}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tfoot>
                      <tr>
                        <td colSpan={7}>{t("Not Found!")}</td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              ) : (
                <Loader />
              )}
              <PaymentView
                show={isVisiblePayment}
                onClose={() => {
                  setIsVisiblePayment(false);
                }}
                PaymentId={paymentId}
              />
              <div className="d-flex justify-content-end mt-2">
                <Stack spacing={2} direction="row" alignItems="center">
                  <div
                    className={`link-button ${
                      currentPage == 1 ? "disabled" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handlePreviousClick();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <KeyboardArrowLeftIcon />
                    <span className="basic-text" style={{ fontWeight: "600" }}>
                      {t("Previous")}
                    </span>
                  </div>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, page) => {
                      setCurrentPage(page);
                    }}
                    size="small"
                    hideNextButton
                    hidePrevButton
                  />
                  <div
                    className={`link-button ${
                      currentPage == totalPages ? "disabled" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNextClick();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="basic-text" style={{ fontWeight: "600" }}>
                      {t("Next")}
                    </span>
                    <KeyboardArrowRightIcon />
                  </div>
                </Stack>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
